<template>
  <div>
    <header class="modal-header">
      <h3 class="modal-title">{{mode + ' User Roles'}}</h3>
    </header>
    <div class="modal-body">
      <b-form>
        <b-form-group
          label="CODE:"
          label-for="code"
          v-show="mode === 'Edit'">
          <b-form-input
            id="code"
            type="text"
            v-model="userRole.CODE"
            required>
          </b-form-input>
        </b-form-group>
        <b-form-group
          label="NAME:"
          label-for="name">
          <b-form-input
            id="name"
            type="text"
            v-model="userRole.NAME"
            required>
          </b-form-input>
        </b-form-group>
        <b-form-group
          label="STATUS:"
          label-for="status">
          <c-switch
            color="success"
            variant="pill"
            size="lg"
            v-model="userRole.STATUS"
            :checked="getStatus" />
        </b-form-group>
      </b-form>
    </div>
    <footer class="modal-footer">
      <b-btn :size="'sm'" @click="$emit('close')">Cancel</b-btn>
      <b-btn :variant="'primary'" :size="'sm'" @click="handleSubmit" :disabled="isFetching">{{mode === 'Add' ? 'Add' : 'Update'}}</b-btn>
    </footer>
  </div>
</template>
<script>
import { Switch as cSwitch } from '@coreui/vue'
import server from '@/services/server'

export default {
  name: 'user-roles-modal',
  props: {
    mode: String,
    model: Object
  },
  data () {
    return {
      userRole: { ...this.model } || {},
      isFetching: false
    }
  },
  components: {
    cSwitch
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
      this.isFetching = true
      let payload = {
        mode: this.mode,
        reqBody: [{
          code: this.userRole.CODE,
          name: this.userRole.NAME,
          status: this.getStatus ? 1 : 0
        }]
      }
      this.$store.dispatch('userRole/upsertItem', payload).then(
        resp => this.$emit('close'),
        err => this.$emit('close')
      )
    }
  },
  computed: {
    getStatus () {
      if (this.userRole) {
        return this.userRole.STATUS ? true : false
      } else {
        return false
      }

    }
  }
}
</script>
